import { useEffect, useState } from "react";
import { useUser } from "@context/contexts";
import "@css/ImpersonationIndicator.css";

const UPDATE_INTERVAL_MS = 1000;
const MS_PER_MINUTE = 60000;
const MS_PER_SECOND = 1000;

const formatTimeRemaining = (expiryTime, now) => {
    const diff = expiryTime - now;

    if (diff <= 0) {
        return "Expired";
    }

    const minutes = Math.floor(diff / MS_PER_MINUTE);
    const seconds = Math.floor((diff % MS_PER_MINUTE) / MS_PER_SECOND);
    return `${minutes}m ${seconds}s`;
};

export const ImpersonationIndicator = () => {
    const { impersonationState, endImpersonation } = useUser();
    // A clock that ticks every second while there is an expiry to count down to
    const [now, setNow] = useState(() => Date.now());
    const isCountingDown = Boolean(impersonationState.isImpersonating && impersonationState.tokenExpiryTime);

    useEffect(() => {
        if (!isCountingDown) {
            return undefined;
        }
        const interval = setInterval(() => setNow(Date.now()), UPDATE_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [isCountingDown]);

    const timeRemaining = isCountingDown ? formatTimeRemaining(impersonationState.tokenExpiryTime, now) : "";

    if (!impersonationState.isImpersonating) {
        return null;
    }

    const handleEndImpersonation = async () => {
        await endImpersonation();
    };

    return (
        <div className="impersonation-indicator">
            <div className="impersonation-content">
                <span className="impersonation-label">
                    🔒 Персонификация <strong>{impersonationState.targetLichessId}</strong>
                </span>
                <span className="impersonation-timer">Истекает через {timeRemaining}</span>
                <button
                    className="impersonation-end-btn"
                    onClick={handleEndImpersonation}
                    title="Завершить сеанс персонификации"
                    type="button"
                >
                    Завершить
                </button>
            </div>
        </div>
    );
};
